import script from "./DashboardSidebar.vue?vue&type=script&lang=ts&setup=true"
export * from "./DashboardSidebar.vue?vue&type=script&lang=ts&setup=true"

import "./DashboardSidebar.vue?vue&type=style&index=0&id=144ca6fb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-144ca6fb"]])

export default __exports__